import './index.scss';

$('#js-cta-questions-relevance-modal').on('click', function (e) {
  e.preventDefault();

  const isEnrolled = $(this).data('enrolled');

  if (!isEnrolled) {
    window.open($(this).attr('href'), '_blank');
  }

  $('#js-questions-relevance-modal').modal('hide');
});
